export default __webpack_public_path__ + "static/about-us-header2-60f9be6736fb3381d324341af8fff185.webp";